import {Component, Inject} from '@angular/core';
import {UNPAUSE_GAME_NO_COVERING_LICENCE_ERROR_TYPE, UNPAUSE_GAME_NO_COVERING_LICENCE_MESSAGE} from "../../../consts/LicenceErrors";
import {DatePipe} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {UIStateEnum} from 'src/app/enum/UIStateEnum';
import {DialogBaseComponent} from '../dialog-base/dialog-base.component';
import {ActiveUserService} from '../../../services/active-user.service';
import {SnackbarService} from '../../../services/snackbar.service';
import {GameService} from '../../../services/game.service';
import {IGameQueryResult} from '../../../interfaces/IGameQueryResult';
import {IUnpauseGame} from '../../../interfaces/IUnpauseGame';
import {IApiErrorResponse} from '../../../interfaces/error/IApiErrorResponse';
import {GameStateEnum} from '../../../enum/GameStateEnum';

@Component({
  selector: 'app-unpause-game-dialog',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatButton,
    DatePipe
  ],
  templateUrl: './unpause-game-dialog.component.html',
  styleUrl: './unpause-game-dialog.component.css'
})
export class UnpauseGameDialogComponent {
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  // Paused means the pause has already landed; the pending states mean it is still scheduled. Same command
  // either way, but an admin cancelling a pause that has not happened yet is doing a different thing than one
  // resuming a stopped game, and the copy should not pretend otherwise.
  public readonly isPaused: boolean;

  constructor(private activeUserService: ActiveUserService,
              private snackBarService: SnackbarService,
              private gameService: GameService,
              private matDialogRef: MatDialogRef<UnpauseGameDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {
                game: IGameQueryResult
              }) {
    this.isPaused = this.data.game.State === GameStateEnum.Paused || this.data.game.State === GameStateEnum.NoLicense;
  }

  submit() {
    this.uiState = UIStateEnum.ShowLoading;

    let command: IUnpauseGame = {
      AdminId: this.activeUserService.activeUser().Id,
      GameId: this.data.game.Id
    }

    this.gameService.unpauseGame(command).subscribe({
      next: () => {
        this.matDialogRef.close(true);
        this.snackBarService.openSuccessfulSnackBar(this.isPaused
          ? 'Successfully unpaused the game.'
          : 'Successfully cancelled the scheduled pause.');
      }, error: (res: IApiErrorResponse) => {
        this.uiState = UIStateEnum.ShowData;
        if (res.Error?.ErrorType === UNPAUSE_GAME_NO_COVERING_LICENCE_ERROR_TYPE) {
          this.snackBarService.openErrorSnackBar(UNPAUSE_GAME_NO_COVERING_LICENCE_MESSAGE);
        } else if (res.Error?.ClientErrorMessages?.length > 0) {
          this.snackBarService.openErrorSnackBar(res.Error.ClientErrorMessages.toString());
        } else {
          this.snackBarService.openErrorSnackBar('There was an error unpausing the game');
        }
      }
    })
  }
}
